import React from "react";

// import Logo from "../../assets/icons/icon_logo.svg";

const URLS = {
  REDIRECT: process.env.REACT_APP_REFERER_URL,
  LOGIN: process.env.REACT_APP_LOGIN_URL,
  NEW_JOIN: process.env.REACT_APP_JOIN_URL,
};

const Login = (props) => {
  const handleLogin = (e) => {
    e.preventDefault();
    // const url = `${URLS.LOGIN}/?referer_url=${URLS.REDIRECT}/tutor`;
    const url = `${URLS.LOGIN}/?referer_url=${URLS.REDIRECT}`;
    window.location.assign(url);
    // touchAPI()
    const data = new FormData(e.target);
    const reqData = {};
    for (const [key, value] of data.entries()) {
      reqData[key] = value;
    }
  };

  const linkToJoin = () => {
    window.location.assign(URLS.NEW_JOIN);
  };

  return (
    <div className="ctn-wrp login-page">
      <div className="lg-wrp flx-box">
        <div className="lg-inr">
          <div className="lg-top flx-box">
            <img src="https://img.dongascience.com/air/icon_logo.svg" alt="logo-img" />
          </div>
          <div className="lg-mid">
            <form onSubmit={handleLogin}>
              <button className="lg-mid__btn crs-btn" type="submit">
                통합 로그인
              </button>
            </form>
          </div>

          <div className="lg-bottom flx-box" onClick={linkToJoin}>
            <p>과학동아AiR가 처음이신가요?</p>
            <p className="link-txt crs-btn">가입하러 가기</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Login;
